import MapView from "../components/mapView/MapView";

const MapViewPage = () =>{
    const markers = [
        { lat: 20.9517, lng: 85.0985 },
        { lat: 20.9527, lng: 85.0995 },
      ];
      
    return(
        <MapView  />
    )
}
export default MapViewPage;